import InputField, { InputFieldProps } from './InputField';

export type { InputFieldProps };
export default InputField;
